export const MiscellaneousPaymentRoutes = [
    {
        "url": "/miscellaneous-payment?date&type",
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.miscellaneous-payment",
        "views": {
            "body": {
                "component": "miscellaneousPaymentPageContainer",
            }
        },
        "route_styles": {
            styles: [],
            framework: "bootstrap_v4"
        },
        "params": {
            date: {
                dynamic: true,
            },
            type: {
                dynamic: true,
            }
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/miscellaneous-payment/miscellaneous-payment.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=miscellaneous-payment.routes.js.map